var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    attrs: {
      "id": "__members-area"
    }
  }, [_c('loading-overlay', {
    attrs: {
      "wait-for": true
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };